import styled, { css } from "styled-components"
import PropTypes from "prop-types"
import { fontSize } from "buoy-theme"
import { margin } from "../styledHelpers"

const Text = styled.span`
  font-family: ${props => props.theme.fonts.family};
  font-weight: ${props => props.theme.fonts.weight[props.fontWeight]};
  color: ${props => props.theme.colors[props.color]};
  ${props => fontSize(props.size)};
  letter-spacing: 0.01rem;
  line-height: 1.3;
  ${margin}
  ${props =>
    props.block
      ? css`
          display: block;
        `
      : ""}
  ${props =>
    props.onClick
      ? css`
          cursor: pointer;
        `
      : ""}
`

Text.defaultProps = {
  size: "bodyMain",
  color: "neutralDarkest",
  fontWeight: "light",
}

Text.propTypes = {
  size: PropTypes.string,
  fontWeight: PropTypes.string,
  color: PropTypes.string,
  block: PropTypes.bool,
  onClick: PropTypes.func,
}

export { Text as default }



// WEBPACK FOOTER //
// ./assets/common/components/Text.js